import {createUseStyles} from 'react-jss';
import {FC, ReactNode} from 'react';
import {CssBreakpoints} from 'styles/responsive';

const useDetailGroupStyles = createUseStyles(theme => {
  const colGap = '1rem';
  return {
    defaultContentGroup: {
      alignItems: 'baseLine',
      display: 'flex',
      flexFlow: 'row wrap',
      width: `calc(80% - ${colGap})`,
      columnGap: colGap,

      [`@media (max-width: ${CssBreakpoints.MD}px)`]: {
        flexDirection: 'column',
        width: '100%',
      },
      '@media print': {
        display: 'block',
        width: '100%',
      },
    },
    additionalContentGroup: {
      margin: '1rem 0',
    },
    detailGroupSeparator: {
      border: 0,
      borderTop: `1px solid ${theme.colors.separator}`,
      margin: '0 -1rem',

      [`@media (max-width: ${CssBreakpoints.MD}px)`]: {
        margin: '1.5rem -2rem 0.5rem -2rem',
      },
      [`@media (max-width: ${CssBreakpoints.XS}px)`]: {
        margin: '1.5rem -2rem 0.5rem -0.5rem',
      },

      '@media print': {
        display: 'none',
      },
    },
  };
});

interface DetailGroupProps {
  children: ReactNode[];
  isDefaultContent?: boolean;
  id: string;
}

export const DetailGroup: FC<DetailGroupProps> = ({children, isDefaultContent, id}) => {
  const styles = useDetailGroupStyles();

  const hasChildren = !!children.filter(c => (Array.isArray(c) ? c.length : c))?.length;
  if (!hasChildren) {
    return null;
  }

  return (
    <>
      <div id={id} className={isDefaultContent ? styles.defaultContentGroup : styles.additionalContentGroup}>
        {children}
      </div>
      {!isDefaultContent && <hr className={styles.detailGroupSeparator} aria-hidden='true' />}
    </>
  );
};
